import React from 'react';
import { Card } from 'antd';
import { observer } from 'mobx-react';


import './SummaryChartItemBlock.css';

@observer
class ItemBlock extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <Card.Grid
        onClick={(e) => {
          this.props.onClick ? this.props.onClick(e, this.props.title) : null
        }}
        className={`summary_item_block ${this.props.current ? 'current':''}`}>
        <span className="triangle"></span>
        <span className="block_value">
          {
            typeof this.props.value === 'function' ? this.props.value() : this.props.value
          }
        </span>
        <span className="block_title">
          {
            typeof this.props.title === 'function' ? this.props.title() : this.props.title
          }
        </span>
      </Card.Grid>
    );
  }
}

export default ItemBlock;



// WEBPACK FOOTER //
// ./src/components/SummaryChartItemBlock/SummaryChartItemBlock.jsx